import { useEffect } from 'react';
import { ERROR_TYPE, POPUP_TYPES } from '@/features/Popup/constants';
import { generatePopupConfig } from '@/features/Popup/helpers/generatePopupConfig';
import { usePopup } from '@/features/Popup/usePopup';
import { POPUP_ERROR_MESSAGES } from '@/utilities/constants/placeholder';
import { getGameClientErrorPopup } from '@/utilities/constants/gameClientErrors';
import { useStore } from '@/store/useStore';

type PopupErrorType = keyof typeof POPUP_ERROR_MESSAGES;

const getPopupErrorMessage = (type: string) =>
  POPUP_ERROR_MESSAGES[type as PopupErrorType];

export const useLoadingErrorPopup = (type: string) => {
  const { showPopup } = usePopup();
  const gameFetchErrorCode = useStore((s) => s.gameStatus.gameFetchErrorCode);

  useEffect(() => {
    const errorMessage = getPopupErrorMessage(type);
    if (!errorMessage) {
      return;
    }

    const mappedError = getGameClientErrorPopup(gameFetchErrorCode);

    showPopup(
      generatePopupConfig(ERROR_TYPE.FAILED_TO_FETCH_GAME, {
        errorConfig: {
          errorType: ERROR_TYPE.GENERIC,
          errorMessage: mappedError?.popupMessage ?? errorMessage,
        },
        ...(mappedError
          ? { customConfig: { props: { popupName: mappedError.popupName } } }
          : {}),
      }),
      POPUP_TYPES.PROVIDER,
    );
  }, [showPopup, type, gameFetchErrorCode]);
};
